import React from 'react';
import { Star } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

export const LoyaltySettings = ({ settings, updateSetting }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Star className="h-5 w-5 text-yellow-500" />
        Loyalty Program
      </CardTitle>
      <CardDescription>Configure points and tier rewards</CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="flex items-center justify-between">
        <Label htmlFor="loyalty-enabled">Enable Loyalty Program</Label>
        <Switch id="loyalty-enabled" checked={settings?.loyalty_program_enabled} onCheckedChange={(v) => updateSetting('loyalty_program_enabled', v)} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Points per R1 spent</Label>
          <Input type="number" value={settings?.loyalty_points_per_rand || 1} onChange={(e) => updateSetting('loyalty_points_per_rand', parseInt(e.target.value))} min="1" />
        </div>
        <div className="space-y-2">
          <Label>Points = R1 redemption</Label>
          <Input type="number" value={settings?.loyalty_points_redemption_rate || 100} onChange={(e) => updateSetting('loyalty_points_redemption_rate', parseInt(e.target.value))} min="1" />
        </div>
      </div>
      <div className="border-t pt-4 space-y-3">
        <p className="text-sm font-medium">Tier Thresholds & Discounts</p>
        <div className="grid grid-cols-3 gap-2">
          <div>
            <Label className="text-xs">Silver (pts)</Label>
            <Input type="number" value={settings?.loyalty_tier_silver || 500} onChange={(e) => updateSetting('loyalty_tier_silver', parseInt(e.target.value))} />
          </div>
          <div>
            <Label className="text-xs">Gold (pts)</Label>
            <Input type="number" value={settings?.loyalty_tier_gold || 1500} onChange={(e) => updateSetting('loyalty_tier_gold', parseInt(e.target.value))} />
          </div>
          <div>
            <Label className="text-xs">Platinum (pts)</Label>
            <Input type="number" value={settings?.loyalty_tier_platinum || 3000} onChange={(e) => updateSetting('loyalty_tier_platinum', parseInt(e.target.value))} />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          <div>
            <Label className="text-xs">Silver disc %</Label>
            <Input type="number" value={settings?.loyalty_silver_discount || 5} onChange={(e) => updateSetting('loyalty_silver_discount', parseFloat(e.target.value))} />
          </div>
          <div>
            <Label className="text-xs">Gold disc %</Label>
            <Input type="number" value={settings?.loyalty_gold_discount || 10} onChange={(e) => updateSetting('loyalty_gold_discount', parseFloat(e.target.value))} />
          </div>
          <div>
            <Label className="text-xs">Plat disc %</Label>
            <Input type="number" value={settings?.loyalty_platinum_discount || 15} onChange={(e) => updateSetting('loyalty_platinum_discount', parseFloat(e.target.value))} />
          </div>
        </div>
      </div>
    </CardContent>
  </Card>
);
